<swiper
  [spaceBetween]="0"
  [loop]="true"
  [pagination]="{ clickable: true }"
  [navigation]="true"
  [breakpoints]="breakpointsConfig"

  class="mySwiper"
>
  <ng-template swiperSlide *ngFor="let img of images">
    <img [src]="img" alt="slider" style="width: 100%;" />
  </ng-template>
</swiper>
